const base={
    baseUrl:'http://you.163.com',
    // categoryUrl:'/api/xhr/globalinfo/queryTop.json',
    banerUrl:'/foo/home/banner', //轮播图
    findNew: '/api/xhr/item/getNewItem.json',//首页主体--新鲜好物
    findhot:'/foo/home/hot', //首页-人气推荐
    product:'/foo/home/product', //首页-产品区块
}

export default base;